<template>
  <!--Pre-task Pool-->
  <div class="tasksMain" v-loading="uploadLoading">
    <div class="tasksTop">
      <div class="topSeach">
        <div>
          <el-input placeholder="Search" v-model="input1" class="input-with-select" id="topInput">
            <el-select v-model="selects" slot="prepend" style="width: 100px;text-align: center">
              <el-option label="ID" value="invoice_number"></el-option>
              <el-option label="Recipient" value="recipient_name"></el-option>
              <el-option label="Phone" value="phone"></el-option>
              <el-option label="Address" value="address"></el-option>
            </el-select>
          </el-input>
        </div>
        <div style="margin: 0 16px;width: 260px">
          <el-select v-model="input2" placeholder="">
            <el-option
              v-for="item in option"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
            <div slot="prefix">
              Status:
            </div>
            <div style="clear: both">
            </div>
          </el-select>
        </div>
      </div>
      <div>
        <el-button type="success" round @click="getTask" style="width: 80px;padding: 0">Search</el-button>
        <el-button plain @click="clearAll" style="width: 80px" class="changeFocus">Clear</el-button>
        <!--      <el-button type="primary" plain>主要按钮</el-button>-->
        <!--      <el-button type="primary" round>主要按钮</el-button>-->
        <!--      <el-button type="primary" round class="searchBton">Search</el-button>-->
        <!--              <el-button type="primary" round style="background-color: #CCCCCC" @click="clearSearch">Clear</el-button>-->
      </div>
    </div>
    <div class="addNew">
      <div>
        <div style="padding-left: 16px;font-size: 14px;line-height: 32px;cursor: pointer" v-if="showSelect"
             @click="selectBatchPrint">
          <img src="../assets/image/printer.svg" alt="" style="vertical-align: middle"> Print Selected Label(s)
        </div>
      </div>
      <div>
        <span class="innerSpan" @click="manDialogVisible = true" v-if="admin == 'admin'">Activate Manually</span>
        <el-dropdown placement="bottom-start" @command="changeAdd">
          <el-button type="primary" round style="margin-right: 16px;padding: 9px 16px">
            NEW
            <i class="el-icon-arrow-down el-icon--right" style="margin-bottom: 10px"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="a">Create</el-dropdown-item>
            <el-dropdown-item command="b">
              <el-upload
                class="upload-demo"
                :action=actionUrl
                :headers="config"
                :http-request="httpRequest"
                :show-file-list="false"
              >
                Import
              </el-upload>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="tasksTable" v-loading="loading">
      <div class="innerTop">
        <div class="outTable" v-if="anotherList.length!= 0">
          <el-table
            :data="anotherList"
            style="width: 100%;font-weight: normal;"
            @selection-change="handleSelectionChange">
            <el-table-column
              header-align="center"
              align="center"
              type="selection"
              width="60"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="invoice_number"
              label="ID/Invoice#"
              width="200px"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="recipient_name"
              label="Recipient"
              min-width="40%"
            >
            </el-table-column>
            <el-table-column
              prop="phone"
              label="Phone"
              min-width="35%"
            >
            </el-table-column>
            <el-table-column
              label="Address / Measurement / Weight"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.address_desc }}</div>
                <div style="color: #999999;">{{ scope.row.specification }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="Status"
              align="center"
              width="150px"
            >
              <template slot-scope="scope">
                <div class="green" v-if="scope.row.status == 1">Active</div>
                <div class="pend" v-if="scope.row.status == 0">Pending</div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="actions"
              width="150"
              label="Actions">
              <template slot-scope="scope">
                <div class="action">
                        <span @click="handleedit(1,scope.row)">
                        <img src="../assets/image/edit@2x.png" alt="">
                        </span>
                  <span @click="handleDelete( scope.row)">
                          <img src="../assets/image/delete@2x.png" alt="">
                        </span>
                  <span @click="handleedit(2,scope.row)">
                          <img src="../assets/image/clone@2x.png" alt="">
                        </span>
                  <span @click="handelePrint(scope.row)">
                          <img src="../assets/image/printer.svg" alt="">
                        </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="empty">
          <div>
            <img src="../assets/image/list_blank.png" alt="">
            <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
          </div>
        </div>
        <div class="btomPagin">
          <div class="innerLeft">{{ page }} - <span>{{ anotherList.length }}</span> of <span>{{ total }}</span> items
          </div>
          <div>
            <el-pagination
              :page-size="10"
              layout="prev, pager, next, jumper"
              :total="total"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!--    create-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      :title=title
      :visible.sync="createDialog"
      width="40%">
      <div>
        <el-form :model="createNew" label-position="top" :rules="perTasksRules" status-icon ref="perTasksRef"
                 :show-message="false">
          <el-form-item label="ID/Invoice#" label-width="120px" prop="id" required>
            <el-input v-model="createNew.id" placeholder="ID/Invoice#" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Contact Details" required>
            <contact-input ref="contact1"></contact-input>
          </el-form-item>
          <el-form-item label="Destination" required>
            <compose-input ref="compose1"></compose-input>
          </el-form-item>
          <el-form-item label="Measurement and weight" required>
            <mes-input ref="mesInput"></mes-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
<!--    <el-button type="primary" plain >Cancel</el-button>-->
         <el-button type="danger" @click="cancelCreate" plain>Cancel</el-button>
    <el-button type="primary" @click="confirmCreate" round>Save</el-button>
  </span>
    </el-dialog>
    <!--    delete-->
    <el-dialog
      :close-on-click-modal="false"
      title="Delete Pre-task"
      :visible.sync="dialogVisible"
      width="35%">
      <div style="margin-top: 24px">The Pre-task with ID/Invoice# {{ id }} will be permanently deleted.</div>
      <span slot="footer" class="dialog-footer">
      <el-button type="danger" @click="dialogVisible = false" plain>Cancel</el-button>
      <el-button type="primary" @click="deleteSuccess">Delete</el-button>
      </span>
    </el-dialog>
    <!--    上传成功-->
    <el-dialog
      :close-on-click-modal="false"
      title="Import results"
      :visible.sync="showUpload"
      @close="refreshUpload"
      width="55%">
      <div class="outBox">
        <div>Imported {{ count }} pre-tasks, {{ count - failCount }} successful, {{ failCount }} failed</div>
        <div style="display: flex;margin: 15px 0" v-for="(item,index) in uploadList" :key="index">
          <div style="color: #1F2D42">{{ item.invoice_number }}</div>
          <div v-if="item.is_success == 1" class="succ">Successful</div>
          <div v-if="item.is_success == 0" class="fail">Failed</div>
        </div>
      </div>
      <!--      <span slot="footer" class="dialog-footer">-->
      <!--     <el-button type="danger" @click="dialogVisible = false" plain>Cancel</el-button>-->
      <!--    <el-button type="primary" @click="deleteSuccess">Delete</el-button>-->
      <!--  </span>-->
    </el-dialog>
    <!--    蒙层-->
    <el-dialog
      :visible.sync="dialogVisibles"
      :fullscreen="true"
      :show-close="false"
      :modal="false"
    >
      <div class="fullDialog" @click="dialogVisibles = false">
        <div class="code">{{ code }}</div>
        <div class="zone">{{ zone }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
  </span>
    </el-dialog>
    <!--    手动激活-->
    <el-dialog
      :close-on-click-modal="false"
      title="Activate manually"
      :visible.sync="manDialogVisible"
      @close="closeActive"
      width="35%">
      <div>
        <!--        ID/Invoice#-->
        <el-form label-position="top" :model="activeForm" ref="activeForm" :rules="rulesActive" status-icon
                 :show-message="false">
          <el-form-item label="ID/Invoice#" label-width="120px" prop="activeMan" required>
            <el-input v-model="activeForm.activeMan" placeholder="ID/Invoice#" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
      <el-button type="danger" @click="manDialogVisible = false; activeForm.activeMan = ''" plain>Cancel</el-button>
      <el-button type="primary" @click="activeManually">Activate</el-button>
      </span>
    </el-dialog>
    <!--    no rule-->
    <el-dialog
      :close-on-click-modal="false"
      title="Please select a zone to distribute"
      :visible.sync="zoneDialog"
      width="35%">
      <div>
        <!--        ID/Invoice#-->
        <el-form label-position="top" ref="activeForm" status-icon :show-message="false">
          <el-form-item label="Distribute to" label-width="120px" required>
            <!--            <el-input v-model="selectzone"  placeholder="ID/Invoice#" autocomplete="off"></el-input>-->
            <el-select v-model="selectZone" placeholder="Select a Zone">
              <el-option
                v-for="item in zoneOption"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
      <el-button type="danger" @click="zoneDialog = false;activeForm.activeMan = '';selectZone = ''"
                 plain>Cancel</el-button>
      <el-button type="primary" @click="storedAt">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import composeInput from "@/components/composeInput";
import contactInput from "@/components/contactInput";
import mesInput from "@/components/mesInput";
import store from "@/store";
import {
  activeManual, activeManualZone,
  addPreTask, batchPrint,
  delPreTask,
  editPerTask,
  preTaskList,
  scanPreTask, singlePrint,
  uploadPerTask
} from "@/api/preTask";
import EventBus from "@/ws/eventBus";
import {getZoneList} from "@/api/assigRules";

export default {
  name: "preTask",
  components: {
    composeInput, contactInput, mesInput
  },
  computed: {
    store() {
      return store.state.store
    },
    config() {
      return {token: this.token};
    },
  },
  watch: {
    store: {
      deep: true,
      handler: function (n, o) {
        this.getTaskPoolList()
      },
    },
  },
  data() {
    var validatePass = (rule, value, callback) => {
      callback(new Error(''));
    };
    return {
      actionUrl: process.env.VUE_APP_BASE_URL,
      admin: '',
      activeForm: {
        activeMan: '',
      },
      rulesActive: {
        activeMan: [
          {required: true, message: '', trigger: 'blur'},
          {validator: validatePass, trigger: ''}
        ],
      },
      zoneDialog: false,
      zoneOption: [],
      selectZone: "",
      activeMan: '',
      manDialogVisible: false,
      uploadLoading: false,
      uploadList: [],
      showUpload: false,
      title: 'Create Pre-task',
      dialogVisible: false,
      loading: false,
      createDialog: false,
      selects: 'invoice_number',
      input1: "",
      anotherList: [],
      createNew: {
        id: '',
      },
      page: 1,
      input2: 'all',//status
      option: [
        {name: 'All', id: "all"},
        {name: 'Pending', id: 0},
        {name: 'Active', id: 1}
      ],
      total: 0,
      perTasksRules: {
        id: [{required: true, message: '', trigger: 'blur'}]
      },
      id: '',
      delid: '',
      failCount: '',
      count: '',
      dialogVisibles: false,
      code: "",
      zone: '',
      selectData: [],
      showSelect: false,
    }
  },

  created() {
    this.getTaskPoolList()
    this.admin = JSON.parse(localStorage.getItem('userInfo')).username
  },
  //监听扫码
  mounted() {
    EventBus.$on('autoCreatePre', (barCode) => {
      this.autoCreate(barCode)
    })
  },
  methods: {
    handleSelectionChange(val) {
      this.selectData = val
      if (val.length == 0) {
        this.showSelect = false
      } else {
        this.showSelect = true
      }
    },
    autoCreate(barCode) {
      barCode = barCode.replace(/(\r\n|\r|\n)+/g, '')
      scanPreTask({
        invoice_number: barCode,
        sub_organization_id: this.$store.state.store
      }).then((res) => {
        if (res.code === 200) {
          this.code = barCode
          this.zone = res.data.zone
          this.dialogVisibles = true
          // setTimeout(() => {
          //   this.dialogVisibles = false
          this.getTaskPoolList()
          // }, 6000)
          this.$message({
            message: res.msg,
            type: 'success',
          });
        } else if (res.code == 432) {
          this.$message({
            message: res.msg,
            type: 'warning',
          });
          this.getZoneListData()
          this.activeForm.activeMan = barCode
          this.zoneDialog = true
        } else {
          this.$message({
            message: res.msg,
            type: 'warning',
          });
        }
      }).catch((error) => {
        this.$message({
          message: error.data.msg,
          type: 'warning',
        });
      });
    },
    getTaskPoolList() {
      this.loading = true
      preTaskList({
        page: this.page,
        limit: 10,
        keyword: this.selects,
        keyvalue: this.input1,
        status: this.input2,
        order: 'time desc',
        sub_organization_id: store.state.store,
      }).then(res => {
        this.loading = false
        if (res.code == 200) {
          if (res.data.length == 0) {
            this.anotherList = []
            this.total = 0
          } else {
            this.total = res.data.count
            this.anotherList = res.data.data
          }
        } else {
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      })
    },
    changeAdd(c) {
      if (c == 'a') {
        this.title = 'Create Pre-task'
        this.createDialog = true
      }
    },
    handleCurrentChange(val) {
      this.page = val
      this.getTaskPoolList()
    },
    getTask() {
      this.getTaskPoolList()
    },
    clearAll() {
      this.page = 1
      this.input1 = ''
      this.input2 = ''
      this.getTaskPoolList()
    },
    //关闭弹框 清除表单校验
    cancelCreate() {
      this.clearForm()
      this.createDialog = false
    },
    validateForm() {
      let flag = false
      this.$refs['perTasksRef'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    //新增
    confirmCreate() {
      let valid1 = this.$refs.contact1.validateForm()
      let valid2 = this.$refs.compose1.validateForm()
      let vaild3 = this.$refs.mesInput.validateForm()
      this.validateForm()
      if (this.createNew.id == '' || !valid1 || !valid2 || !vaild3) {
        this.$message({
          message: 'Some information missing',
          type: 'warning'
        });
      } else {
        let contact = this.$refs.contact1.form
        let compose = this.$refs.compose1.changeForm
        let mes = this.$refs.mesInput.mesForm
        let out = Object.assign(contact, compose)
        let form = Object.assign(out, mes)
        form.invoice_number = this.createNew.id
        form.sub_organization_id = this.$store.state.store
        delete form.options
        if (this.title == 'Create Pre-task' || this.title == 'Copy Pre-task') {
          addPreTask(form).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'Pre-task has been created'
              })
              this.clearForm()
              this.createDialog = false
              this.getTaskPoolList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        } else {
          form.id = this.id
          editPerTask(form).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: 'Pre-task has been Edited'
              })
              this.clearForm()
              this.createDialog = false
              this.getTaskPoolList()
            } else {
              this.$message({
                type: 'warning',
                message: res.msg
              })
            }
          })
        }
      }
    },
    clearForm() {
      this.$refs.perTasksRef.clearValidate()
      this.$refs.perTasksRef.resetFields()
      this.createNew.id = ''
      this.$refs.compose1.validateClear()
      this.$refs.contact1.validateClear()
      this.$refs.mesInput.validateClear()
    },
    handleDelete(row) {
      this.id = row.invoice_number
      this.delid = row.id
      this.dialogVisible = true
    },
    //单个打印
    handelePrint(row) {
      singlePrint({
        id: row.id
      }).then(res => {
        if (res.code == 200) {
          window.open(process.env.VUE_APP_BASE_IMGURL + res.data.data)
        } else {
          this.$message({
            message: res.msg,
            type: 'warning',
          });
        }
      })
    },
    //多个打印
    selectBatchPrint() {
      if (this.selectData.length == 1) {
        this.handelePrint(this.selectData[0])
      } else {
        let arrId = []
        this.selectData.forEach(i => {
          arrId.push(i.id)
        })
        batchPrint({
          task_ids: arrId
        }).then(res => {
          if (res.code == 200) {
            window.open(process.env.VUE_APP_BASE_IMGURL + res.data.data)
          } else {
            this.$message({
              message: res.msg,
              type: 'warning',
            });
          }
        })
      }
    },
    deleteSuccess() {
      delPreTask({
        id: this.delid,
        sub_organization_id: this.$store.state.store
      }).then(res => {
        if (res.code == 200) {
          this.dialogVisible = false
          this.getTaskPoolList()
          this.$message({
            type: 'success',
            message: 'Pre-task has been deleted'
          })
        } else {
          this.$message({
            type: 'warning',
            message: res.msg
          })
        }
      })
    },
    //编辑 (需要优化)
    handleedit(a, row) {
      if (a == 1) {
        this.title = 'Edit Pre-task'
      } else {
        this.title = 'Duplicate Pre-task'
      }
      this.createDialog = true
      this.$nextTick(() => {
        this.createNew.id = row.invoice_number
        this.$refs.contact1.form.phone = row.phone
        this.$refs.contact1.form.recipient_name = row.recipient_name
        this.id = row.id
        this.$refs.compose1.changeForm.address = row.address
        this.$refs.compose1.changeForm.city = row.city
        this.$refs.compose1.changeForm.input2 = row.abs
        this.$refs.compose1.changeForm.postcode = row.postcode
        this.$refs.mesInput.mesForm.height = row.height
        this.$refs.mesInput.mesForm.weight = row.weight
        this.$refs.mesInput.mesForm.width = row.width
        this.$refs.mesInput.mesForm.length = row.length
      })
    },
    httpRequest(data) {
      let _this = this
      let formData = new FormData()
      formData.append('file', data.file)
      formData.append('sub_organization_id', this.$store.state.store)
      this.uploadLoading = true
      uploadPerTask(formData).then(res => {
        this.uploadLoading = false
        if (res.code == 200) {
          this.showUpload = true
          this.uploadList = res.data
          this.count = res.data.length
          let fail = []
          this.uploadList.forEach(i => {
            if (i.is_success == 1) {
              fail.push(i)
            }
          })
          this.failCount = fail.length
        } else {
          _this.$message({
            message: res.msg,
            type: 'warning'
          });
        }
      }).catch(err => {
      })
      // }

    },
    //上传后刷新
    refreshUpload() {
      this.getTaskPoolList()
    },
    validateForms() {
      let flag = false
      this.$refs['activeForm'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    getZoneListData() {
      getZoneList({
        page: 1,
        limit: 100
      }).then(res => {
        this.loadings = false
        if (res.code == '200') {
          this.zoneOption = res.data.data
          this.zoneDialog = true
        } else {
          this.$message({
            message: res.msg,
            type: 'warning',
          });
        }
      }).catch(err => {
        this.$message({
          message: err.msg,
          type: 'warning',
        });
      })
    },
    closeActive() {
      this.activeForm.activeMan = ''
      this.$refs.activeForm.clearValidate('activeMan')
    },
    activeManually() {
      if (this.activeForm.activeMan != '') {
        activeManual({
          invoice_number: this.activeForm.activeMan,
          sub_organization_id: this.$store.state.store
        }).then(res => {
          this.code = this.activeForm.activeMan
          if (res.code == 432) {
            this.manDialogVisible = false
            this.$message({
              message: res.msg,
              type: 'warning',
            });
            this.getZoneListData()
            this.zoneDialog = true
          } else if (res.code == 200) {
            this.manDialogVisible = false
            this.getTaskPoolList()
            this.zone = res.data.zone
            this.dialogVisibles = true
            this.$message({
              message: res.msg,
              type: 'success',
            });
          } else if (res.code == 421) {
            this.$refs.activeForm.validateField('activeMan')
            this.$message({
              message: res.msg,
              type: 'warning',
            });
          } else {
            this.$message({
              message: res.msg,
              type: 'warning',
            });
          }
        })
      } else {

      }
    },
    storedAt() {
      if (this.selectZone == '') {
        this.$message({
          type: "warning",
          message: "Some information missing"
        })
      } else {
        activeManualZone({
          invoice_number: this.activeForm.activeMan,
          zone: this.selectZone,
          sub_organization_id: this.$store.state.store
        }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: 'success',
            });
            this.zone = res.data.zone
            this.dialogVisibles = true
            this.getTaskPoolList()
            this.zoneDialog = false
          } else {
            this.$message({
              message: res.msg,
              type: 'warning',
            });
          }
        })
      }
    }
  },

  destroyed() {
    EventBus.$off('autoCreatePre')
  },
}
</script>

<style scoped lang="less">
.tasksMain {
  /deep/ .el-dialog.is-fullscreen {
    background-color: rgba(255, 255, 255, 0.8);;
    border-radius: 0;
  }

  .fullDialog {
    text-align: center;
    color: #1F2D42;
    padding-top: 10%;

    .code {
      line-height: 48px;
      font-size: 48px;
    }

    .zone {
      font-size: 200px;
      font-weight: bold;
      color: #1F2D42;
      line-height: 200px;
      margin-top: 48px;
    }
  }

  .outBox {
    margin-top: 24px;
    height: 50vh;
    overflow: auto;

    .succ {
      padding: 0 16px;
      height: 22px;
      line-height: 22px;
      background: #82D237;
      border-radius: 11px;
      color: #FFFFFF;
      margin-left: 24px;
    }

    .fail {
      padding: 0 16px;
      height: 22px;
      line-height: 22px;
      background: #E95646;
      border-radius: 11px;
      color: #FFFFFF;
      margin-left: 24px;
    }
  }

  .tasksTop {
    padding: 16px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #E0E0E0;
    display: flex;
    justify-content: space-between;

    /deep/ .changeFocus:focus {
      border: 1px solid #DCDFE6;
      color: #606266;
    }

    .topSeach {
      display: flex;

      /deep/ .el-input--prefix .el-input__inner {
        padding-left: 88px;
      }

      /deep/ .el-input__prefix {
        color: #1F2D42;
      }
    }

  }

  .addNew {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;

    .innerSpan {
      font-size: 14px;
      margin-right: 16px;
      border-bottom: 3px solid #1F2D42;
      cursor: pointer;
    }
  }

  .tasksTable {
    margin-top: 16px;
    font-weight: normal;
    font-size: 13px;

    .innerTop {
      .outTable {
        margin-top: 17px;
        //height: 58vh;
        //overflow: auto;
        /deep/ .el-table th.el-table__cell > .cell {
          padding-left: 26px;
        }

        /deep/ .el-table-column--selection .cell {
          padding-left: 30px;
        }

        .action {
          span {
            cursor: pointer;
          }

          img {
            width: 16px;
            margin-right: 16px;
          }
        }

        .green {
          padding: 0 16px;
          line-height: 22px;
          background: #82D237;
          border-radius: 11px;
          text-align: center;
          font-weight: bold;
          color: #FFFFFF;
          display: inline-block;
        }

        .pend {
          padding: 0 16px;
          line-height: 22px;
          background: #BCBEBF;
          border-radius: 11px;
          text-align: center;
          font-weight: bold;
          color: #FFFFFF;
          display: inline-block;
        }
      }

      .btomPagin {
        margin-top: 10px;
        display: flex;
        justify-content: space-between;
        padding-left: 16px;

        .innerLeft {
          font-size: 16px;
          font-family: SFPro-Regular, SFPro;
          font-weight: 400;
          color: #1F2D42;
          line-height: 20px;
        }
      }
    }

    .empty {
      width: 200px;
      height: 387px;
      margin: 20px auto;
      position: relative;

      img {
        width: 100%;
        height: 200px;
      }

      div {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  .footers {
    width: calc(100% - 72px);
    z-index: 2;
    height: 64px;
    background: #1F2D42;
    position: fixed;
    bottom: 0;
    margin-left: -32px;
    line-height: 64px;
    display: flex;
    justify-content: space-between;
    padding-right: 48px;
    padding-left: 32px;
    color: #FFFFFF;
  }

  .unassigned {
    background-color: #BCBEBF;
  }

  .assigned {
    background: #AB81F3;
    border-radius: 16px;
    padding: 0 12px;
    color: #FFFFFF;
    height: 32px;
    line-height: 32px;
    font-size: 13px;
    font-weight: bold;
  }

  .another {
    position: absolute;
    top: 27px;
    left: 140px;
  }

  .completed {
    background-color: #82D237;
  }

  .transit {
    background: #32B0F8;
    border-radius: 16px;
    padding: 0 12px;
    color: #FFFFFF;
    height: 32px;
    line-height: 32px;
    font-size: 13px;
    font-weight: bold;
  }

  .failed {
    background: #E95646;
  }

  .deleted {
    background: #1F2D42;
  }

  .detialInner {
    .changeStatus {
      color: #FFFFFF;
      padding: 0 12px;
      height: 32px;
      line-height: 32px;
      border-radius: 16px;
      font-size: 13px;
      font-weight: bold;
      color: #FFFFFF;
      position: absolute;
      top: 27px;
      left: 140px;
    }

    .arrvingTime {
      padding: 0 12px;
      height: 32px;
      line-height: 32px;
      border-radius: 16px;
      font-size: 13px;
      font-weight: bold;
      color: #FFFFFF;
    }
  }

}
</style>

